const TopWinter = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none">
    {/* Background landscape — stretches horizontally to fill container */}
    <svg
      viewBox="0 0 376 200"
      preserveAspectRatio="none"
      width="100%"
      height="100%"
    >
      <path
        d="M376 138.438C357.61 142.527 320.786 141.747 300 137.08L309.611 158.723L352.804 165.08C361.101 163.577 368.93 162.133 376 160.789V138.438Z"
        fill="#CADDFC"
      />
      <path
        d="M376 150.638C314.816 147.416 305.437 129.037 274.301 140.372C261.864 144.898 248.398 157.346 218.041 157.346C159.532 157.346 174.277 143.536 137.643 138.337C116.239 135.305 97.0837 135.481 76.8261 143.038C52.0113 152.279 25.5645 127.368 0 134.324L0 200H376V150.638Z"
        fill="white"
      />
      <path
        d="M151.207 159.151C167.617 181.265 211.717 183.089 231.877 169.369C252.038 155.648 248.082 154.174 274 139.927C261.605 144.438 248.184 156.845 217.929 156.845C159.617 156.845 174.312 143.08 137.801 137.899C128.893 136.629 120.366 135.943 112 136.103C124.219 139.3 141.391 145.912 151.207 159.151Z"
        fill="#CADDFC"
      />
    </svg>

    {/* Foreground elements — maintain aspect ratio, stay centered */}
    <svg
      viewBox="0 0 376 200"
      preserveAspectRatio="xMidYMin meet"
      width="100%"
      height="100%"
    >
      {/* Left snowman */}
      <path
        d="M48.7993 120.355V151.796H61.5503L58.6398 120.355H48.7993Z"
        fill="#4A5DAD"
      />
      <path
        d="M55.1861 47.8069C50.8755 53.8402 39.0921 75.7552 39.981 77.7768C40.8698 79.7905 41.9947 80.3254 41.9947 80.3254C41.9947 80.3254 29.8337 99.7783 31.0215 101.029C32.2092 102.28 34.341 103.578 34.341 103.578C34.341 103.578 32.6183 109.863 28.111 113.127C23.6037 116.392 27.1985 119.829 29.4561 121.025C31.7058 122.22 36.8503 122.22 36.8503 122.22C36.8503 122.22 40.7912 128.348 48.4685 128.419C56.1459 128.49 57.7662 125.674 57.7662 125.674C57.7662 125.674 61.9903 128.773 65.7267 127.082C69.4553 125.39 70.0217 122.362 70.0217 122.362C70.0217 122.362 74.5369 125.28 79.8622 124.328C82.3558 123.88 87.2013 121.198 85.6517 119.263C84.6527 118.012 77.699 110.272 74.3873 101.871C74.3873 101.871 77.4866 102.012 79.2486 100.746C81.0106 99.4794 81.0814 98.3546 81.0814 98.3546C74.7256 93.3517 69.6913 87.0038 65.9391 79.3422C65.9391 79.3422 70.061 77.7925 68.9676 76.5261C61.9353 68.3768 58.0651 43.7952 55.1861 47.8227V47.8069Z"
        fill="white"
      />
      <path
        d="M43.2061 80.3568C44.9523 81.3558 46.8244 81.3244 48.9247 79.4916C51.9846 82.166 55.131 81.9772 58.3404 79.4916C61.1486 81.2457 63.2253 80.758 64.8693 78.9645C63.8703 81.2772 62.5566 83.1178 58.5292 80.8839C55.1782 83.9674 51.9846 84.1483 48.9719 80.8839C45.6445 83.1965 44.4725 81.7019 43.2061 80.3568Z"
        fill="#8FAEF4"
      />
      <path
        d="M35.9536 103.326C37.2751 104.663 39.5327 104.6 42.8601 102.909C45.7784 105.74 49.0822 106.236 52.9366 103.326C57.0505 106.496 60.3701 106.197 62.4388 103.121C66.4663 105.056 69.7307 103.892 72.6648 101.461C70.305 104.214 67.6934 106.409 63.367 104.836C60.9678 107.377 57.3101 109.674 53.031 104.836C48.8541 107.384 45.5424 106.905 42.805 104.317C39.1551 105.701 36.6458 105.654 35.9536 103.333V103.326Z"
        fill="#8FAEF4"
      />

      {/* Right snowman */}
      <path
        d="M310.197 123.298V148.598H320.457L318.115 123.298H310.197Z"
        fill="#4A5DAD"
      />
      <path
        d="M315.336 64.9208C311.867 69.7756 302.386 87.4099 303.101 89.0366C303.816 90.657 304.721 91.0874 304.721 91.0874C304.721 91.0874 294.936 106.74 295.891 107.747C296.847 108.753 298.563 109.798 298.563 109.798C298.563 109.798 297.176 114.855 293.549 117.482C289.923 120.109 292.815 122.875 294.632 123.837C296.442 124.799 300.582 124.799 300.582 124.799C300.582 124.799 303.753 129.73 309.93 129.787C316.108 129.844 317.412 127.578 317.412 127.578C317.412 127.578 320.811 130.071 323.818 128.711C326.818 127.35 327.274 124.913 327.274 124.913C327.274 124.913 330.907 127.261 335.192 126.495C337.198 126.134 341.097 123.976 339.851 122.419C339.047 121.413 333.451 115.184 330.786 108.424C330.786 108.424 333.28 108.538 334.698 107.519C336.116 106.5 336.173 105.595 336.173 105.595C331.059 101.569 327.008 96.4612 323.989 90.2962C323.989 90.2962 327.305 89.0493 326.425 88.0302C320.767 81.4727 317.653 61.6927 315.336 64.9335V64.9208Z"
        fill="white"
      />
      <path
        d="M305.696 91.1127C307.101 91.9166 308.608 91.8912 310.298 90.4164C312.76 92.5685 315.292 92.4166 317.874 90.4164C320.134 91.8279 321.805 91.4355 323.128 89.9924C322.324 91.8533 321.267 93.3344 318.026 91.5368C315.33 94.018 312.76 94.1636 310.336 91.5368C307.658 93.3977 306.715 92.1951 305.696 91.1127Z"
        fill="#8FAEF4"
      />
      <path
        d="M299.86 109.595C300.924 110.671 302.74 110.62 305.418 109.259C307.766 111.538 310.424 111.937 313.526 109.595C316.836 112.146 319.507 111.905 321.172 109.43C324.413 110.987 327.04 110.051 329.401 108.095C327.502 110.31 325.4 112.076 321.919 110.81C319.988 112.855 317.045 114.703 313.602 110.81C310.241 112.861 307.576 112.475 305.373 110.392C302.437 111.506 300.417 111.468 299.86 109.601V109.595Z"
        fill="#8FAEF4"
      />

      {/* Snowflakes */}
      <path
        d="M26.2797 31.4001C26.2797 34.8901 23.4497 37.7201 19.9597 37.7201C16.4697 37.7201 13.6396 34.8901 13.6396 31.4001C13.6396 27.9101 16.4697 25.0801 19.9597 25.0801C23.4497 25.0801 26.2797 27.9101 26.2797 31.4001Z"
        fill="white"
      />
      <path
        d="M106.859 57.19C106.859 60.61 104.089 63.38 100.669 63.38C97.2494 63.38 94.4795 60.61 94.4795 57.19C94.4795 53.77 97.2494 51 100.669 51C104.089 51 106.859 53.77 106.859 57.19Z"
        fill="white"
      />
      <path
        d="M265.859 6.18999C265.859 9.60999 263.089 12.38 259.669 12.38C256.249 12.38 253.479 9.60999 253.479 6.18999C253.479 2.76999 256.249 0 259.669 0C263.089 0 265.859 2.76999 265.859 6.18999Z"
        fill="white"
      />
      <path
        d="M352.18 76.491C354.168 76.491 355.78 74.8792 355.78 72.891C355.78 70.9028 354.168 69.291 352.18 69.291C350.192 69.291 348.58 70.9028 348.58 72.891C348.58 74.8792 350.192 76.491 352.18 76.491Z"
        fill="white"
      />
      <path
        d="M88.3695 19.1895C88.3695 20.2495 87.5095 21.1195 86.4495 21.1195C85.3895 21.1195 84.5195 20.2595 84.5195 19.1895C84.5195 18.1195 85.3795 17.2695 86.4495 17.2695C87.5195 17.2695 88.3695 18.1295 88.3695 19.1895Z"
        fill="white"
      />
      <path
        d="M118.37 100.19C118.37 101.25 117.509 102.12 116.449 102.12C115.389 102.12 114.52 101.26 114.52 100.19C114.52 99.1195 115.379 98.2695 116.449 98.2695C117.519 98.2695 118.37 99.1295 118.37 100.19Z"
        fill="white"
      />
      <path
        d="M158.37 20.1895C158.37 21.2495 157.509 22.1195 156.449 22.1195C155.389 22.1195 154.52 21.2595 154.52 20.1895C154.52 19.1195 155.379 18.2695 156.449 18.2695C157.519 18.2695 158.37 19.1295 158.37 20.1895Z"
        fill="white"
      />
      <path
        d="M287.11 95.3806C287.11 96.7606 285.99 97.8706 284.62 97.8706C283.25 97.8706 282.13 96.7506 282.13 95.3806C282.13 94.0106 283.25 92.8906 284.62 92.8906C285.99 92.8906 287.11 94.0106 287.11 95.3806Z"
        fill="white"
      />
      <path
        d="M307.11 35.3806C307.11 36.7606 305.99 37.8706 304.62 37.8706C303.25 37.8706 302.13 36.7506 302.13 35.3806C302.13 34.0106 303.25 32.8906 304.62 32.8906C305.99 32.8906 307.11 34.0106 307.11 35.3806Z"
        fill="white"
      />

      {/* Central snowman */}
      <path
        d="M177.126 51.6031C177.126 51.6031 184.12 34.9871 201.226 32.2702C218.333 29.5532 230.031 56.8609 230.031 56.8609L225.905 59.7791L215.213 52.9742C215.213 52.9742 215.792 55.8043 211.427 57.3515C207.05 58.8986 173.038 61.6155 177.126 51.6031Z"
        fill="#4A5DAD"
      />
      <path
        d="M230.044 138.873C230.044 160.395 212.597 177.841 191.076 177.841C169.554 177.841 152.108 160.395 152.108 138.873C152.108 117.351 169.554 99.9052 191.076 99.9052C212.597 99.9052 230.044 117.351 230.044 138.873Z"
        fill="white"
      />
      <path
        d="M219.98 85.4527C219.98 100.974 207.389 113.565 191.868 113.565C176.346 113.565 163.755 100.974 163.755 85.4527C163.755 69.931 176.346 57.34 191.868 57.34C207.389 57.34 219.98 69.9184 219.98 85.4527Z"
        fill="white"
      />
      <path
        d="M212.233 66.081C213.415 64.383 216.937 56.2825 212.975 56.5466C209.012 56.8108 200.912 57.251 191.868 55.2259C182.824 53.2008 176.749 48.6977 174.711 51.9681C172.686 55.2259 172.233 61.578 175.39 62.6849C183.843 67.1628 206.635 68.5338 212.233 66.0936V66.081Z"
        fill="#313B77"
      />
      <path
        d="M235.352 59.6907C235.352 62.6843 232.924 65.1245 229.918 65.1245C226.911 65.1245 224.484 62.6969 224.484 59.6907C224.484 56.6844 226.911 54.2568 229.918 54.2568C232.924 54.2568 235.352 56.6844 235.352 59.6907Z"
        fill="white"
      />
      <path
        d="M199.554 82.1572C201.284 82.1572 202.686 80.755 202.686 79.0252C202.686 77.2955 201.284 75.8932 199.554 75.8932C197.824 75.8932 196.422 77.2955 196.422 79.0252C196.422 80.755 197.824 82.1572 199.554 82.1572Z"
        fill="#313B77"
      />
      <path
        d="M185.541 78.3815C185.541 80.1173 184.132 81.5135 182.409 81.5135C180.685 81.5135 179.276 80.1048 179.276 78.3815C179.276 76.6583 180.685 75.2495 182.409 75.2495C184.132 75.2495 185.541 76.6583 185.541 78.3815Z"
        fill="#313B77"
      />
      <path
        d="M178.861 87.5652L191.905 84.3074C193.691 84.6848 194.006 91.0243 191.314 91.5777L178.861 87.5652Z"
        fill="#8FAEF4"
      />
      <path
        d="M193.202 97.7022C192.221 97.7022 191.265 97.5638 190.384 97.2997C189.869 97.1362 189.592 96.5953 189.743 96.0796C189.906 95.5639 190.447 95.2871 190.963 95.4381C193.063 96.0922 195.843 95.7148 197.868 94.4947C198.799 93.9287 199.982 92.935 200.258 91.4256C200.359 90.8973 200.862 90.5451 201.39 90.6457C201.919 90.7463 202.271 91.2495 202.17 91.7778C201.843 93.5136 200.673 95.0607 198.875 96.1551C197.202 97.1613 195.164 97.7022 193.202 97.7022Z"
        fill="#313B77"
      />
      <path
        d="M168.472 106.268C160.95 125.878 163.868 142.154 169.768 157.475C175.956 158.041 181.516 157.663 186.082 155.739C180.837 138.305 177.202 121.526 180.459 107.564L168.472 106.268Z"
        fill="#4A5DAD"
      />
      <path
        d="M166.623 97.8296C166.623 97.8296 175.63 104.169 192.371 102.308C209.113 100.446 214.006 97.8045 215.352 99.8925C216.698 101.98 214.17 104.735 214.17 104.735C214.17 104.735 218.912 107.968 214.761 110.496C210.61 113.024 199.529 114.999 187.579 114.672C177.064 114.383 165.353 113.062 164.485 110.37C163.064 105.98 165.705 104.484 165.705 104.484C165.705 104.484 161.253 97.4145 166.623 97.8296Z"
        fill="#4A5DAD"
      />
      <path
        d="M164.812 139.879L165.957 140.445C166.498 140.709 167.139 140.596 167.554 140.156L169.605 137.992C170.057 137.514 170.787 137.426 171.34 137.791L173.366 139.112C173.932 139.476 174.686 139.376 175.139 138.86L177.152 136.558C177.579 136.08 178.284 135.954 178.85 136.269L181.391 137.69C181.164 136.596 180.95 135.514 180.762 134.445L178.296 132.948C177.718 132.596 176.976 132.722 176.548 133.238L174.711 135.414C174.259 135.942 173.491 136.055 172.913 135.665L170.649 134.143C170.095 133.778 169.353 133.854 168.888 134.344L166.9 136.483C166.498 136.923 165.844 137.049 165.315 136.785L164.359 136.319C164.485 137.514 164.649 138.697 164.837 139.879H164.812Z"
        fill="#313B77"
      />
      <path
        d="M183.063 144.936C182.799 144.948 182.522 144.898 182.283 144.76L179.566 143.099C178.988 142.747 178.246 142.873 177.818 143.389L175.981 145.565C175.529 146.093 174.761 146.206 174.183 145.816L171.919 144.307C171.365 143.93 170.623 144.018 170.158 144.508L168.17 146.647C167.768 147.087 167.114 147.213 166.585 146.948L166.321 146.823C166.661 148.106 167.026 149.389 167.416 150.659C167.919 150.835 168.472 150.709 168.837 150.319L170.887 148.156C171.34 147.678 172.07 147.59 172.623 147.955L174.648 149.275C175.214 149.64 175.969 149.54 176.422 149.036L178.434 146.735C178.862 146.244 179.566 146.131 180.132 146.445L183.076 148.093C183.352 148.244 183.654 148.294 183.956 148.244C183.654 147.137 183.365 146.043 183.088 144.948L183.063 144.936Z"
        fill="#313B77"
      />
    </svg>
  </svg>
)

export default TopWinter
